import {
  CPS,
  FINANCE,
  FUNDING,
  INSURANCE,
  LOGISTICS,
  PLANET_DIGITAL_MEDIA,
  SMARTBOARD,
  TRAILER_LEASING,
  TRUCK_RENTAL,
  TRUCK_SALES,
  UNITED,
} from './divisions'

export const COMPANY_TYPE = 1
export const ORGANIZATION_TYPE = 2
export const SOURCE_TYPE = 3
export const LANGUAGE = 4
export const NATIONALITY = 5
export const RED_FLAG_STATUS = 6
export const ACTIVITY_TYPE = 8
export const NEXT_STEP = 9
export const PROSPECT_GRADE = 10
export const ACCOUNT_SOURCE = 11
export const STAGE = 12
export const EFFORT_LEVEL = 13
export const COMPETING_TMS = 14
export const PRICING_MODEL = 15
export const PAYMENT_TERMS = 16
export const TRUCK_STOP = 17
export const PROGRAM = 18
export const REMITTANCE_METHOD = 19
export const REMITTANCE_PERIOD = 20
export const COMPETING_FACTORING_PROVIDER = 21
export const PROSPECT_SOURCE = 25
export const EMAIL_SENDER = 26
export const CONTRACT_LOST = 27
export const I_GIVE_UP_REASON = 28
export const OPERATING_STATUS = 29
export const OPERATION_CLASIFICATION = 30
export const CARRIER_OPERATION = 31
export const CARGO_CARRIED = 32
export const FACTORING_COMPANY = 33
export const INSURANCE_COMPANY = 34
export const ADDITIONAL_CONTACT_TITLE = 35
export const OPPORTUNITY_TYPE = 36
export const PROSPECT_STAGE_SB = 37
export const PROSPECT_STAGE_FND = 38
export const PROSPECT_STAGE_INS = 39
export const PROSPECT_STAGE_CPS = 40
export const PROSPECT_STAGE_TS = 41
export const PROSPECT_STAGE_TR = 42
export const PROSPECT_STAGE_TL = 43
export const PROSPECT_STAGE_FIN = 44
export const PROSPECT_STAGE_LOG = 45
export const PROSPECT_STAGE_PDM = 46
export const PROSPECT_STAGE_UNITED = 47
export const LEGAL_BUSINESS_STRUCTURE = 48
export const LOGISTIC_CUSTOMER_LOAD_TYPE = 49
export const LOGISTIC_CUSTOMER_LOAD_EQUIPMENT = 50
export const CUSTOMER_TYPE = 51
export const LOAD_COST = 52
export const SOURCE_CUSTOMER_LOGISTICS = 53
export const DEALERSHIP_TYPE = 54
export const SOURCE_FINANCE_DEALERS = 55

export const AUTHORITY_TYPE = 57
export const TMS_TYPE = 58
export const CUSTOMER_ANNUAL_SALES = 59

const divisionToProspectStage = new Map()
divisionToProspectStage.set(SMARTBOARD, PROSPECT_STAGE_SB)
divisionToProspectStage.set(FUNDING, PROSPECT_STAGE_FND)
divisionToProspectStage.set(INSURANCE, PROSPECT_STAGE_INS)
divisionToProspectStage.set(CPS, PROSPECT_STAGE_CPS)
divisionToProspectStage.set(TRUCK_SALES, PROSPECT_STAGE_TS)
divisionToProspectStage.set(TRAILER_LEASING, PROSPECT_STAGE_TL)
divisionToProspectStage.set(TRUCK_RENTAL, PROSPECT_STAGE_TR)
divisionToProspectStage.set(FINANCE, PROSPECT_STAGE_FIN)
divisionToProspectStage.set(LOGISTICS, PROSPECT_STAGE_LOG)
divisionToProspectStage.set(PLANET_DIGITAL_MEDIA, PROSPECT_STAGE_PDM)
divisionToProspectStage.set(UNITED, PROSPECT_STAGE_UNITED)

export const prospectStageForDivision = (divisionId) => {
  return divisionToProspectStage.get(divisionId)
}
